// -------------------------------------
// Dependencies
// -------------------------------------
import iamotaEventHandler from 'scripts/helpers/iamota-event-handler';
var SUBSCRIPTION_ROW = '.selling-plan__option:not(.selling-plan__option--one-time)';
var SUBSCRIPTION_SUBTITLE = '.selling-plan__subtitle:not(.selling-plan__subtitle--one-time)';
var PDP_OFFER = '.ordergroove__offer--pdp:not(.ordergroove__offer--pdp-trial)';
iamotaEventHandler.subscribe('productForm:init', _ref => {
  var {
    iamForm
  } = _ref;
  var sellingPlan = iamForm.getCurrentSellingPlan();
  updateOrdergrooveOfferWithFrequency(sellingPlan);
}, {
  source: "ordergroove-offer--show-frequency.js"
});
iamotaEventHandler.subscribe('productForm:sellingPlan:changed', _ref2 => {
  var {
    sellingPlan
  } = _ref2;
  updateOrdergrooveOfferWithFrequency(sellingPlan);
}, {
  source: "ordergroove-offer--show-frequency.js"
});
function updateOrdergrooveOfferWithFrequency(sellingPlan) {
  if (!sellingPlan || sellingPlan.purchase_type === 'onetime') return;
  document.querySelectorAll(PDP_OFFER).forEach(offer => {
    offer.querySelectorAll('og-optin-button').forEach(optinButton => {
      var row = optinButton.closest(SUBSCRIPTION_ROW);
      if (!row) return;
      var subtitle = row.querySelector(SUBSCRIPTION_SUBTITLE);
      if (subtitle && subtitle.textContent !== sellingPlan.label) {
        subtitle.remove();
        subtitle = null;
      }
      if (!subtitle) {
        var span = document.createElement('span');
        span.textContent = sellingPlan.label;
        span.classList.add('selling-plan__subtitle', 'h5');
        optinButton.parentNode.insertBefore(span, optinButton.nextSibling);
      }
    });
  });
}